import React from 'react';
import { IconButton } from '../components';
import { makeStyles } from '../styles';
import { CloseIcon } from '@ui/icons';

const useStyles = makeStyles((theme) => ({
  root: {
    color: theme.palette.action.active,
    position: 'absolute',
    top: theme.spacing(1),
    marginRight: theme.spacing(1),
    right: 0,
  },
}));

export const CloseButton: React.FC<React.ComponentProps<typeof IconButton>> = (props) => {
  const classes = useStyles();

  return (
    <IconButton {...props} aria-label='close' classes={classes}>
      <CloseIcon fontSize='large' />
    </IconButton>
  );
};
